import axios from 'axios';
import helpers from '../helpers/helpers'
import i18n from '../language';
import { router } from '../router/router';
import store from '../store/store';

axios.interceptors.request.use(config => {
    config.baseURL = store.getters.baseUrl;
    // Auth token
    const token = store.getters.authToken;
    if (!config.headers.Authorization && token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Culture
    const lang = store.getters.currentCulture;
    config.headers["Accept-Language"] = lang || 'bg';
    config.headers["Accept"] = '*/*';

    return config;
});

// Add a 401 response interceptor
axios.interceptors.response.use(response => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    if (!error) {
        return Promise.reject(error);
    }

    if (!error.response) {
        const regex = /Network Error/gi;
        const found = error.toString().match(regex);
        if (found) {
            error = {
                response: { statusText: i18n.t('responseErrors.networkError') }
            }
        }
        return Promise.reject(error);
    }

    if (error.response.status) {
        switch (error.response.status) {
            case 400:
                helpers.translateError(error);
                break;
            case 401:
                store.dispatch('logout').then(() => {
                    /* router.push('/login'); */
                });
                error.response.statusText = i18n.t('notifications.unauthorized');
                const returnUrl = router.currentRoute.fullPath;
                if (returnUrl && returnUrl.indexOf('login') > -1) {
                    router.push({ name: 'login' }); // returnUrl от към login. получава се зацикляна
                } else {
                    router.push({ name: 'login', query: { returnUrl: `${router.currentRoute.fullPath}` } });
                }

                break;
            case 403:
                error.response.statusText = i18n.t('notifications.forbidden');
                break;
            default:
        }
    }

    return Promise.reject(error);
});

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    patch: axios.patch,
    all: axios.all
}
